import { useCallback } from "react";

import { Action } from "types/generated";
import { AccessResult, checkAllowedAction } from "utils/access";

import { AiIntegrationView } from "../useSearchAiIntegrations/gql";

const useCanUpdateAiIntegration = (): ((integration: AiIntegrationView) => AccessResult) => {
  return useCallback(
    (integration: AiIntegrationView) => checkAllowedAction(integration, Action.AiIntegrationUpdate),
    []
  );
};

export default useCanUpdateAiIntegration;
